/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Padding_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Padding" |
*
* @param {Styles_Padding_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_padding_aria_label = /** @type {((inputs?: Styles_Padding_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Padding_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Remplissage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Polsterung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Imbottitura")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Набивка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Relleno")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("填充")
	if (locale === "ja") return /** @type {LocalizedString} */ ("パディング")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गद्दी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Acolchoamento")
	return /** @type {LocalizedString} */ ("Padding")
});